import React, { useEffect, useState } from 'react';
import { AvatarProps } from '../../types';

const Avatar: React.FC<AvatarProps> = ({ user, size = "w-8 h-8", className = "", style = {}, textSize = "text-sm" }) => {
  const [imageError, setImageError] = useState<boolean>(false);
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  const getUserInitials = (): string => {
    if (user?.displayName && user.displayName.trim()) {
      const firstName = user.displayName.trim().split(' ')[0];
      if (firstName && firstName.length > 0) {
        const initial = firstName[0].toUpperCase();
        return initial;
      }
    }
    if (user?.email && user.email.trim()) {
      const emailPart = user.email.split('@')[0];
      if (emailPart.length > 0) {
        const initial = emailPart[0].toUpperCase();
        return initial;
      }
    }
    return 'U';
  };

  const handleImageError = (): void => {
    setImageError(true);
    setImageLoaded(false);
  };

  const handleImageLoad = (): void => {
    setImageError(false);
    setImageLoaded(true);
  };

  useEffect(() => {
    setImageError(false);
    setImageLoaded(false);
  }, [user?.photoURL]);

  const getImageUrl = (): string | null => {
    if (!user?.photoURL) return null;
    if (imageError && user?.photoURL?.includes('googleusercontent.com')) {
      const baseUrl = user.photoURL.split('=s')[0];
      return `${baseUrl}=s96-c`;
    }
    return user.photoURL;
  };

  const imageUrl: string | null = getImageUrl();
  const shouldShowImage: boolean = Boolean(imageUrl && !imageError);

  return (
    <div className={`${size} rounded-md relative overflow-hidden ${className}`} style={style}>
      {imageUrl && (
        <img 
          src={imageUrl}
          alt={user?.displayName || 'Profile'} 
          className="w-full h-full rounded-md object-cover absolute inset-0"
          onError={handleImageError}
          onLoad={handleImageLoad}
          referrerPolicy="no-referrer"
          style={{ 
            zIndex: imageError ? 0 : 2,
            opacity: imageError ? 0 : 1,
            transition: 'opacity 0.2s ease'
          }}
        />
      )}
      <div 
        className="w-full h-full rounded-md flex items-center justify-center bg-[color:var(--pmc-primary)] absolute inset-0"
        style={{ 
          zIndex: 1,
          opacity: (!imageUrl || imageError || !imageLoaded) ? 1 : 0,
          transition: 'opacity 0.2s ease'
        }}
      >
        <span className={`text-white ${textSize} font-medium`}>{getUserInitials()}</span>
      </div>
    </div>
  );
};

export default Avatar;


